import React from 'react'
import { Editor, Frame } from '@craftjs/core'
import lz from 'lzutf8'

import AksiNyata from 'app/PelatihanMandiriPage/components/CLWidgets/AksiNyata'
import Assessment from 'app/PelatihanMandiriPage/components/CLWidgets/Assessment'
import Button from 'app/PelatihanMandiriPage/components/CLWidgets/Button'
import Container from 'app/PelatihanMandiriPage/components/CLWidgets/Container'
import ContentWrapper from '../components/CLWidgets/ContentWrapper'
import Document from 'app/PelatihanMandiriPage/components/CLWidgets/Document'
import Heading from 'app/PelatihanMandiriPage/components/CLWidgets/Heading'
import Image from 'app/PelatihanMandiriPage/components/CLWidgets/Image'
import Module from 'app/PelatihanMandiriPage/components/CLWidgets/Module'
import PageCard from 'app/PelatihanMandiriPage/components/CLWidgets/PageCard'
import GenericPageCard from 'app/PelatihanMandiriPage/components/CLWidgets/GenericPageCard'
import Text from 'app/PelatihanMandiriPage/components/CLWidgets/Text'
import Toolkit from 'app/PelatihanMandiriPage/components/CLWidgets/Toolkit'
import Topic from 'app/PelatihanMandiriPage/components/CLWidgets/Topic'
import VideoCard from 'app/PelatihanMandiriPage/components/CLWidgets/VideoCard'
import { NotFoundError } from 'utils/customError'

import type { CLItem, CLWidgetSchema } from 'types/microlearning'

export interface CLRendererProps {
  clItem: CLItem
  topicId?: number
  topicName?: string
  trackerWidgetData?: {
    source: 'reference_tab' | 'kb_page'
    kbPageId: string
  }
}

const CLRenderer = ({
  clItem,
  topicId,
  topicName,
  trackerWidgetData,
}: CLRendererProps) => {
  const widgetObjects = clItem?.widgetObjects ?? []

  const rawSchemaString: string = lz.decompress(
    lz.decodeBase64(clItem?.contentSchema)
  )
  const rawSchema: CLWidgetSchema = JSON.parse(
    rawSchemaString.length > 0 ? rawSchemaString : '{}'
  )

  let schemaString = '{}'
  let shouldRenderFrame = schemaString !== '{}'

  try {
    Object.keys(rawSchema).forEach((widgetId) => {
      if (widgetId !== 'ROOT') {
        const widget = rawSchema[widgetId]
        widget.props = {
          ...widget.props,
          trackerWidgetData: {
            ...trackerWidgetData,
            widgetValue: widget.props,
            widgetType: widget.custom?.name,
            widgetId,
          },
        }
      }
    })

    if (widgetObjects.length > 0 && rawSchemaString.length > 0) {
      widgetObjects.forEach((widgetObject) => {
        /**
         * TODO: revisit this one
         * Somehow the linter rejecting `structuredClone()`
         * --
         * use `JSON.stringify()` and `JSON.parse()` instead
         * */
        const responseData = JSON.parse(
          JSON.stringify(widgetObject.responseData)
        )
        rawSchema[widgetObject.widgetNode].props = {
          ...rawSchema[widgetObject.widgetNode].props,
          ...responseData,
          topicId,
          topicName,
          trackerWidgetData: {
            ...rawSchema[widgetObject.widgetNode].props.trackerWidgetData,
            widgetValue: responseData,
          },
        }
      })
    }

    schemaString = JSON.stringify(rawSchema)
    shouldRenderFrame = schemaString !== '{}'
  } catch (e) {
    throw new NotFoundError(window.location.pathname, e)
  }

  return (
    <Editor
      resolver={{
        AksiNyata,
        Assessment,
        Button,
        Container,
        ContentWrapper,
        Document,
        Heading,
        Image,
        Module,
        PageCard,
        GenericPageCard,
        Text,
        Toolkit,
        Topic,
        VideoCard,
      }}
      enabled={false}
    >
      {shouldRenderFrame && <Frame data={schemaString} key={clItem.id} />}
    </Editor>
  )
}

export default CLRenderer
